export type WorkshopLeafKey =
  | 'workshopVehiclesNotArrived'
  | 'workshopOverpricedOrders'
  | 'workshopOverdueOrders'
  | 'workshopOrdersBelowMinimumMargin'
  | 'workshopUnclosedWarrantyClaims'
  | 'workshopOrdersWithoutDateOrPrice'
  | 'workshopRepeatedRepairs'
  | 'workshopToCompleteToday'
  | 'workshopTodaysVehicleArrivals';

export type WorkshopGroupKey = 'workshopCritical' | 'workshopWarning' | 'workshopToday';

export interface WorkshopWidget {
  key: WorkshopLeafKey;
  labelKey: string;
}

export interface WorkshopWidgetGroup {
  groupKey: WorkshopGroupKey;
  labelKey: string;
  widgets: readonly WorkshopWidget[];
}

export const WORKSHOP_WIDGET_GROUPS = [
  {
    groupKey: 'workshopCritical',
    labelKey: 'critical',
    widgets: [
      {key: 'workshopVehiclesNotArrived', labelKey: 'vehiclesNotArrived'},
      {key: 'workshopOverpricedOrders', labelKey: 'overpricedOrders'},
      {key: 'workshopOverdueOrders', labelKey: 'overdueOrders'},
      {key: 'workshopOrdersBelowMinimumMargin', labelKey: 'ordersBelowMinimumMargin'},
    ],
  },
  {
    groupKey: 'workshopWarning',
    labelKey: 'warning',
    widgets: [
      {key: 'workshopUnclosedWarrantyClaims', labelKey: 'unclosedWarrantyClaims'},
      {key: 'workshopOrdersWithoutDateOrPrice', labelKey: 'ordersWithoutDateOrPrice'},
      {key: 'workshopRepeatedRepairs', labelKey: 'repeatedRepairs'},
    ],
  },
  {
    groupKey: 'workshopToday',
    labelKey: 'today',
    widgets: [
      {key: 'workshopToCompleteToday', labelKey: 'toCompleteToday'},
      {key: 'workshopTodaysVehicleArrivals', labelKey: 'todaysVehicleArrivals'},
    ],
  },
] as const satisfies readonly WorkshopWidgetGroup[];
